import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { DatePipe } from "@angular/common";
import { HttpRequestService } from "./http-request-service";
import { RequestUrls } from "../api-urls";
import { RolePermissionsService } from "./role-permissions.service";

@Injectable()

export class CommonService {

    public hideMenu: boolean = false;
    public adminRole: any = {}
    public crossReferenceData: any = {};
    public orgnizationData: any;
    public orgnizationMaintData: any = {};
    public devicesData: any = {};
    public assetDetails: any = {};
    public applicationData: any = {};
    public softwareVersionData: any = {};
    public configurationApprovalData: any = {};
    public deviceApplicationData: any = {};
    public deviceDetails: any = {};
    public deviceUpdates: any = {};
    public registrationRequest: any = {};
    public provisioningRequest: any = {};
    public artifactRepositoryData: any = {};
    public deviceConfigProfile: any = {};
    public profileDetails: any = {};
    public applicationProfileData: any = {};
    public navigationTitle: string = '';
    public isOrgDashBoard: boolean = false;
    public deviceDetailsTabType: string = '';
    public isConfigVersionUpdateView: boolean = false;
    public startupParametersData: any = {};
    public commandStatusHistoryNavigation: boolean = false;
    public organizationList: Array<any> = [];
    public configPackagesData: any = {};
    public deviceId: String = '';
    public deviceMetricData: any = {};
    public deviceMetricDataRedirect: any = {};
    public configPackageUpdatesQueue: any = {};
    public isDeviceAppPageLoading: boolean = false;
    public releaseManagerData: any;

    dates: any = {};
    constructor(private title: Title, private httpService: HttpRequestService,
        private rolePermissions: RolePermissionsService) {
        this.createDates();
    }

    public setNavigationTitleData(title: string) {
        this.navigationTitle = title;
        if (!title) {
            localStorage.removeItem('navigation-title');
        } else {
            localStorage.setItem('navigation-title', title);
        }

    }

    releaseBuilderTabActive: any;
    public setReleaseBuilderTabActive(data: any) {
        this.releaseBuilderTabActive = data;
    }

    public getReleaseBuilderTabActive() {
        return this.releaseBuilderTabActive;
    }

    public setReleaseManagerData(data: any) {
        this.releaseManagerData = data;
    }

    public getReleaseManagerData() {
        return this.releaseManagerData;
    }

    public deploymentManagerData: any;
    public setDeploymentManagerData(data: any) {
        this.deploymentManagerData = data;
    }

    public getDeploymentManagerData() {
        return this.deploymentManagerData;
    }

    public setDeviceAppPageLoading(value: boolean) {
        this.isDeviceAppPageLoading = value;
    }

    public getDeviceAppPageLoading() {
        return this.isDeviceAppPageLoading;
    }


    public setConfigPackageUpdatesQueue(data: any) {
        this.configPackageUpdatesQueue = data;
    }

    public getConfigPackageUpdatesQueue() {
        return this.configPackageUpdatesQueue;
    }

    public setDeviceMetricData(data: any) {
        this.deviceMetricData = data;
    }

    public getDeviceMetricData() {
        return this.deviceMetricData;
    }

    public setIsOrgDashBoard(data: boolean) {
        this.isOrgDashBoard = data;
    }

    public getIsOrgDashBoard() {
        return this.isOrgDashBoard;
    }

    public getNavigationTitleData() {
        return this.navigationTitle;
    }

    public setDevicesData(data: any) {
        this.devicesData = data;
    }

    public getDevicesData() {
        return this.devicesData;
    }

    public setArtifactRepoData(data: any) {
        this.artifactRepositoryData = data;
    }

    public getArtifactRepoData() {
        return this.artifactRepositoryData;
    }

    public setDeviceDetails(data: any) {
        this.deviceDetails = data;
    }

    public getDeviceDetails() {
        return this.deviceDetails;
    }

    public setProfileDetails(data: any) {
        this.profileDetails = data;
    }

    public getProfileDetails() {
        return this.profileDetails;
    }

    public setDeviceUpdates(data: any) {
        this.deviceUpdates = data;
    }

    getDeviceUpdates() {
        return this.deviceUpdates;
    }

    public setConfigurationApprovalData(data: any) {
        this.configurationApprovalData = data;
    }

    public getConfigurationApprovalData() {
        return this.configurationApprovalData;
    }

    public setRegistrationRequestData(data: any) {
        this.registrationRequest = data;
    }

    public getRegistrationRequest() {
        return this.registrationRequest;
    }

    public setSoftwareVersionData(data: any) {
        this.softwareVersionData = data;
    }

    public getSoftwareVersionData() {
        return this.softwareVersionData;
    }

    public setApplicationData(data: any) {
        this.applicationData = data;
    }

    public getApplicationData() {
        return this.applicationData || {};
    }

    public setApplicationProfileData(data: any) {
        this.applicationProfileData = data;
    }

    public getApplicationProfileData() {
        return this.applicationProfileData;
    }

    public setOrgnizationdata(data: any) {
        this.orgnizationData = data;
    }

    public getOrgnizationdata() {
        return this.orgnizationData;
    }

    public setOrgnizationMaintdata(data: any) {
        this.orgnizationMaintData = data;
    }

    public setCrossReferncedata(data: any) {
        this.crossReferenceData = data;
    }

    public getCrossReferncedata() {

        return this.crossReferenceData;
    }

    public setHideSideMenu(flag: boolean) {
        this.hideMenu = flag;
    }

    public getHideSideMenu() {
        return this.hideMenu;
    }

    public setAdminRoles(data: any = {}) {
        this.adminRole = data;
    }

    public getAdminRoles() {
        return this.adminRole || {};
    }

    public setMaintenanceDates(dates: any) {
        this.dates = dates || {};
    }

    public getMaintenanceDates() {
        return this.dates || {};
    }

    public setDeviceApplicationData(data: any) {
        this.deviceApplicationData = data;
    }

    public getdeviceApplicationData() {
        return this.deviceApplicationData;
    }

    public setProvisioningRequest(data: any) {
        this.provisioningRequest = data;
    }

    public getProvisioningRequest() {
        return this.provisioningRequest;
    }

    public setDeviceConfigProfile(data: any) {
        this.deviceConfigProfile = data;
    }

    public getDeviceConfigProfile() {
        return this.deviceConfigProfile;
    }

    public setDeviceDetailsTabType(tabType: string) {
        this.deviceDetailsTabType = tabType;
    }

    public getDeviceDetailsTabType() {
        return this.deviceDetailsTabType;
    }

    public setIsConfigVersionUpdateView(data: boolean) {
        this.isConfigVersionUpdateView = data;
    }

    public getIsConfigVersionUpdateView() {
        return this.isConfigVersionUpdateView;
    }

    public setStartupParametersData(data: any) {
        this.startupParametersData = data;
    }

    public getStartupParametersData() {
        return this.startupParametersData;
    }

    public setCommandStatusHistoryNavigation(data: boolean) {
        this.commandStatusHistoryNavigation = data;
    }

    public getCommandStatusHistoryNavigation() {
        return this.commandStatusHistoryNavigation;
    }

    public setOrganizationList(data: any) {
        this.organizationList = data;
    }

    public getOrganizationList() {
        return this.organizationList;
    }

    public setConfigPackagesData(data: any) {
        this.configPackagesData = data;
    }

    public getConfigPackagesData() {
        return this.configPackagesData;
    }
    isConfigPackageSwAddView: boolean = false;
    public setIsConfigPackageSW(data: boolean) {
        this.isConfigPackageSwAddView = data;
    }

    public getIsConfigPackageSW() {
        return this.isConfigPackageSwAddView;
    }

    importAssets: any = [];
    setImportAssetsData(values: any) {
        this.importAssets = values;
    }

    getImportAssetsData() {
        return this.importAssets || [];
    }

    setDeviceId(deviceId: string) {
        this.deviceId = deviceId;
    }

    getDeviceId() {
        return this.deviceId;
    }

    setDeviceMetricDataRedirect(data: string) {
        this.deviceMetricDataRedirect = data;
    }

    getDeviceMetricDataRedirect() {
        return this.deviceMetricDataRedirect;
    }

    public createDates() {
        let endDateString: any = new Date();
        let date = endDateString.getDate();
        let month = endDateString.getMonth() + 1;
        let year = endDateString.getFullYear();
        month = month < 10 ? '0' + month : '' + month;
        this.dates.startDate = year + "-" + month + "-" + (date - 7);
        this.dates.endDate = year + "-" + month + "-" + (date);
        this.setMaintenanceDates(this.dates);
    }

    formatReleaseDate(dateValue: any, format: string = 'MM-dd-yyyy'): string | null {
        if (!dateValue) {
            return null;
        }
        const dateOnly = dateValue.includes('T') ? dateValue.split('T')[0] : dateValue;
        return new DatePipe('en-US').transform(dateOnly, format);
    }

    selectedFormIndex: number = 0;
    setSelectedFormIndex(index: any) {
        this.selectedFormIndex = index;
    }

    getSelectedFormIndex() {
        return this.selectedFormIndex;
    }

    setTitle() {
        let title: any = window.location.href;
        title = title.split('/');
        this.title.setTitle('Saas Device Management -' + title[title.length - 1]);
    }
    public setAssetDetails(value: any) {
        this.assetDetails = value;
    }

    public getAssetDetails() {
        return this.assetDetails;
    }

    formatDate(date: any = null) {
        let d: any = new Date(date);
        let month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [month, day, year].join('-');
    }

    formatDateWithReverse(date: any = null) {
        let d: any = new Date(date);
        let month = '' + (d.getMonth() + 1),
            day = '' + (d.getDate() + 1),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    notificationCount: number = 0;
    configPackageApprovalCount() {
        let request: any = {
            action: RequestUrls.configuration_packages.count,
            noMessage: true,
            success: (data: any) => {
                if (data > 0) {
                    this.notificationCount = data;
                } else {
                    this.notificationCount = 0;
                }
            }
        }
        this.httpService.getRequest(request);
    }


    showNotification: boolean = true;
    getNotificationCount() {
        this.totalNotificationCount = 0;
        if (this.rolePermissions.hasPermission('CONFIGURATION_PACKAGES.APPROVE')) {
            this.configPackageApprovalCount();
        }
        if (this.rolePermissions.hasPermission('REGISTER_DEVICES.VIEW')) {
            this.getRegistrationRequestCount();
        } else if (this.rolePermissions.hasPermission('PROVISIONING_REQUESTS.VIEW')) {
            this.getProvisioningRequestCount();
        } else if (this.rolePermissions.hasPermission('ALERT_MESSAGES.VIEW')) {
            //TODO: Temp stopping queries are taking longer in Production
            //this.getAlertMessagesCount();
        }
    }

    alertMessagesCount: number = 0;
    alertMessagesCounts: Array<any> = [];
    totalNotificationCount: number = 0;
    getAlertMessagesCount() {
        let request: any = {
            action: RequestUrls.alert_messages['countbymessagetypes'],
            hideLoader: true,
            success: (data: any) => {
                if (data) {
                    this.totalNotificationCount = 0;
                    this.alertMessagesCounts = [];
                    data = data || {};
                    let keys: Array<any> = Object.keys(data);
                    keys.forEach((o, i) => {
                        this.alertMessagesCounts.push({ name: o, count: data[o] });
                        this.totalNotificationCount = this.totalNotificationCount + data[o];
                    });
                    this.totalNotificationCount = this.totalNotificationCount + this.notificationCount + this.regRequestCount + this.provRequestCount + this.provRequestForApproval;
                }
            }
        };
        this.httpService.getRequest(request);
    }

    regRequestCount: number = 0;
    getRegistrationRequestCount() {
        let request: any = {
            action: RequestUrls.registration_requests['pending'],
            hideLoader: true,
            success: (data: any) => {
                if (data > 0) {
                    this.regRequestCount = data;
                } else {
                    this.regRequestCount = 0;
                }
                if (this.rolePermissions.hasPermission('ALERT_MESSAGES.VIEW')) {
                    //TODO: Temp stopping queries are taking longer in Production
                    //this.getAlertMessagesCount();
                }
                if (this.rolePermissions.hasPermission('PROVISIONING_REQUESTS.VIEW')) {
                    this.getProvisioningRequestCount();
                }
            }
        };
        this.httpService.getRequest(request);

    }

    provRequestCount: number = 0;
    getProvisioningRequestCount() {
        let request: any = {
            action: RequestUrls.provisioning_requests['pending'],
            hideLoader: true,
            success: (data: any) => {
                if (data > 0) {
                    this.provRequestCount = data;
                } else {
                    this.provRequestCount = 0;
                }
                this.getProvisioningWaitingForApprovalCount();
                // if (this.rolePermissions.hasPermission('ALERT_MESSAGES.VIEW')) {
                //     this.getAlertMessagesCount();
                // }
            }
        };
        this.httpService.getRequest(request);

    }

    provRequestForApproval: number = 0;
    getProvisioningWaitingForApprovalCount() {
        let request: any = {
            action: RequestUrls.provisioning_requests['waiting_for_approval'],
            hideLoader: true,
            success: (data: any) => {
                if (data > 0) {
                    this.provRequestForApproval = data;
                } else {
                    this.provRequestForApproval = 0;
                }
            }
        };
        this.httpService.getRequest(request);

    }

    getDate(date: any) {
        let dates: Array<any> = date ? date.split('T') : [];
        if (dates.length > 1) {
            let times: Array<any> = dates[1].split('.');
            return times[0] + ' (UTC)' || '';
        }
        return date;
    }

    chartData: any;
    setBarChartsData(data: any) {
        this.chartData = data || null;
    }

    getBarchartsData() {
        return this.chartData;
    }

    resetChartsData() {
        this.chartData = null;
    }
    dashboardCardStatus: string = '';
    setDashboardCardStatus(status: string) {
        this.dashboardCardStatus = status;
    }

    getDashboardCardStatus() {
        return this.dashboardCardStatus;
    }

    breadCrumbName: string = '';
    setBreadCrumbName(name: string) {
        this.breadCrumbName = name;
    }

    getBreadCrumbName() {
        return this.breadCrumbName;
    }

    breadCrumbs: Array<any> = [];
    setBreadCrumbs(breadCrumbs: Array<any>) {
        this.breadCrumbs = breadCrumbs;
    }

    getBreadCrumbs() {
        return this.breadCrumbs;
    }

    // String sorting
    onSort(list: Array<any>, sortableColumns: any, column: string) {
        let clients: Array<any> = [];
        if (!sortableColumns[column]) {
            clients = [...list].sort((a, b) => {
                let leftValue: any = a[column] ? a[column] : '';
                let righttValue: any = b[column] ? b[column] : '';
                if (leftValue < righttValue) {
                    return -1
                } else if (leftValue > righttValue) {
                    return 1;
                } else {
                    return 0;
                }
            });
            sortableColumns[column] = 'asc';
        } else if (sortableColumns[column] == 'asc') {
            clients = [...list].sort((a, b) => {
                let leftValue: any = a[column] ? a[column] : '';
                let righttValue: any = b[column] ? b[column] : '';
                if (leftValue < righttValue) {
                    return 1
                } else if (leftValue > righttValue) {
                    return -1;
                } else {
                    return 0;
                }
            });
            sortableColumns[column] = 'desc';
        } else {
            clients = [...list];
            sortableColumns[column] = null;
        }
        return clients || [];
    }

    // Date sorting
    onDateSort(list: Array<any>, sortableColumns: any, column: string) {
        let clients: Array<any> = [];
        if (!sortableColumns[column]) {
            clients = [...list].sort((a, b) => {
                let leftValue: any = a[column] ? new Date(a[column]) : '';
                let righttValue: any = b[column] ? new Date(b[column]) : '';
                if (leftValue < righttValue) {
                    return -1
                } else if (leftValue > righttValue) {
                    return 1;
                } else {
                    return 0;
                }
            });
            sortableColumns[column] = 'asc';
        } else if (sortableColumns[column] == 'asc') {
            clients = [...list].sort((a, b) => {
                let leftValue: any = a[column] ? new Date(a[column]) : '';
                let righttValue: any = b[column] ? new Date(b[column]) : '';
                if (leftValue < righttValue) {
                    return 1
                } else if (leftValue > righttValue) {
                    return -1;
                } else {
                    return 0;
                }
            });
            sortableColumns[column] = 'desc';
        } else {
            clients = [...list];
            sortableColumns[column] = null;
        }
        return clients || [];
    }

    sortingUrls(sortableColumns: any) {
        let url: string = '';
        for (var key in sortableColumns) {
            if (sortableColumns[key]) {
                if (url) {
                    url = url + `&sort=${key},${sortableColumns[key]}`;
                } else {
                    url = `&sort=${key},${sortableColumns[key]}`
                }
            }
        }
        return url;
    }

    deviceOnline(date: any) {
        var heartbeatTime = new Date(date);
        var heartBeatTimeAfterSixMinutes = new Date(heartbeatTime.getTime() + (8 * 60 * 1000));
        let presentDateTime = new Date();
        if (presentDateTime < heartBeatTimeAfterSixMinutes) {
            return true;
        } else {
            return false;
        }
    }

    sortData(data: any) {
        data.sort((a: any, b: any) => {
            if (a.text > b.text) {
                return 1;
            } else if (a.text < b.text) {
                return -1;
            }
            return 0; // add default return statement
        })

        return data;
    }

    //Safe state logic

    updateStatusIcons(clients: any): void {
        clients.forEach((data: any) => {
            let item = data.safeStateIconDto;
            // First check initating STOP Command
            // If safe state is enabled for the target application
            if (data.softwareStatus == 'Stopped' && item.parentChildApp == 1) {
                data.safeState = true;
                return;
            }
            // if safe state is not enabled
            if (!(item.parentAppSafeStateEnaled == 1 || item.parentChildApp == 2)) {
                data.safeState = true;
                return;
            }
            // check for safe state timeout value, deny if it is not set
            if (item.safeStateTimeout === null) {
                data.safeState = false;
                return;
            }
            // If target app is a child app
            if (item.parentChildApp == 2) {
                // if yes then checking for parent app installed or not

                if (item.parentAppInstalled == 0) {
                    data.safeState = true;
                    return;
                }

                if (item.devAppSafeState == -1) {
                    //Parent application not received safe state and in started state
                    if (item.targetApplicationStarted == 1) {
                        data.safeState = false;
                        return;
                    } else {
                        //For application  on device allowing the command as even though parent application  did not received 
                        // the safe stae yet but its not even started, software status is 
                        data.safeState = true;
                        return;
                    }
                } else {
                    // if parent application has received the safe state data
                    if (item.devAppSafeState == 1) {
                        if (this.isSafeStateExpired(item)) {
                            //Safe state is true but expired and parent application is in started state
                            if (item.targetApplicationStarted == 1) {
                                data.safeState = false;
                                return;
                            } else {
                                // For application on device with parent application, allowing the command as safe state is true "
                                // 					+ "but expired but parent application is in state
                                data.safeState = true;
                                return;
                            }
                        } else {
                            //Allowing command 
                            data.safeState = true;
                            return;
                        }

                    } else {
                        if (this.isSafeStateExpired(item)) {
                            //parent safe state is false and expired but is in started state
                            if (item.targetApplicationStarted == 1) {
                                data.safeState = false;
                                return;
                            } else {
                                // For application on device with parent application, allowing the command as safe state is true "
                                // 					+ "but expired but parent application is in state
                                data.safeState = false;
                                return;
                            }
                        } else {
                            //parent safe state is false and not expired
                            data.safeState = false;
                            return;
                        }
                    }
                }
            } else {
                if (item.devAppSafeState == -1) {
                    //Application did not yet received safe state data
                    data.safeState = false;
                    return;
                } else {
                    if (item.devAppSafeState == 1) {
                        if (this.isSafeStateExpired(item)) {
                            //Application safe state is true but expired
                            data.safeState = false;
                            return;
                        } else {
                            //Allowing command 
                            data.safeState = true;
                            return;
                        }
                    } else {
                        //safe state is false
                        if (this.isSafeStateExpired(item)) {
                            //Application safe state is true but expired
                            data.safeState = false;
                            return;
                        } else {
                            //Denied command 
                            data.safeState = false;
                            return;
                        }
                    }

                }
            }
        })
    }

    private isSafeStateExpired(item: any) {
        var infoStatusDate = new Date(item.safeStatusReceiveDate);
        var afterSafeStateTimeout = new Date(infoStatusDate.getTime() + ((item.safeStateTimeout / 60) * 60 * 1000));
        let presentDateTime = new Date();
        if (presentDateTime > afterSafeStateTimeout) {
            return true
        } else
            return false;
    }

}